/* eslint-disable import/extensions, import/no-unresolved */
import React from 'react';
import ReactHTMLParser from 'react-html-parser';
import { FONT_SIZE } from '@latitude/core/utils/constants';
import { StaticImage } from 'gatsby-plugin-image';

import {
  StyledHeroBranded,
  ImageBox,
  LeaderDetailsWrapper,
  DetailsContainer,
  StyledText,
  LeadershipPageLayout
} from '../../../components/Leadership';

export default props => {
  const title = 'Mark Brudenell';
  const content = 'Chief Risk Officer & Executive General Manager, Risk';

  return (
    <LeadershipPageLayout title={title} {...props}>
      <StyledHeroBranded
        title={title}
        text={ReactHTMLParser(content)}
        breadcrumbs={[
          {
            name: 'About us',
            href: '/about-us/'
          },
          {
            name: 'Our company',
            href: '/about-us/our-company/'
          },
          {
            name: 'Mark Brudenell'
          }
        ]}
        imageContent={
          <ImageBox>
            <StaticImage
              alt={title}
              src="../images/mark-brudenell-1.webp"
              width={450}
              quality={100}
              placeholder="dominantColor"
            />
          </ImageBox>
        }
      />
      <LeaderDetailsWrapper>
        <DetailsContainer display="flex">
          <StyledText fontSize={FONT_SIZE.LARGE}>
            Mark was appointed Chief Risk Officer of Latitude Financial Services
            in August 2022 and Executive General Manager Risk in May 2023. He
            has held senior leadership roles across risk management and business
            operations since joining Latitude in 2018.
            <br />
            <br />
            Before Latitude, Mark had an extensive career in government
            administration, including as Senior Adviser to the Prime Minister of
            Australia between 2015 and 2018, where he was responsible for
            developing major policy and reform initiatives. He began his career
            at Deloitte.
          </StyledText>
          <StyledText fontSize={FONT_SIZE.LARGE}>
            Mark is currently a Board Member of the Australian Retail Credit
            Association and Chair of the Australian Finance Industry
            Association’s Strategy Committee. He holds a Bachelor of Arts with
            First Class Honours from the University of Melbourne.
          </StyledText>
        </DetailsContainer>
      </LeaderDetailsWrapper>
    </LeadershipPageLayout>
  );
};
